"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { FormComponentsContext } from './use-form-components.mjs';

function FormComponentsProvider({
  children,
  DataBuilderForm
}) {
  const value = useMemo(() => ({ DataBuilderForm }), [DataBuilderForm]);
  return /* @__PURE__ */ jsx(FormComponentsContext.Provider, { value, children });
}

export { FormComponentsProvider };
